import { Event, EventType } from '@angular/router';

import {
  EventSearchResult,
  ExhibitorSearchResult,
  PostSearchResult,
  ProductSearchResult,
  SearchResult,
} from '@planone/bau365/data-access-search';

import { ApiExhibitorNewsfeedResult, NewsfeedExhibitorApiResponse } from '../service/newsfeed-api-response.models';

export function isNavigationStart(e: Event | undefined) {
  if (!e || !Object.prototype.hasOwnProperty.call(e, 'type')) return false;
  const event = e as Event & { type: EventType };
  return event.type === EventType.NavigationStart;
}

export function mapApiResultsToFrontend(results: NewsfeedExhibitorApiResponse): SearchResult[] {
  return results.items.map((result) => mapApiResultToFrontend(result)).filter(Boolean);
}

export function mapApiResultToFrontend(result: ApiExhibitorNewsfeedResult): SearchResult {
  switch (result.type) {
    case 'post':
      return mapPostApiResultToFrontend(result);
    case 'product':
      return mapProductApiResultToFrontend(result);
    case 'exhibitor':
      return mapExhibitorApiResultToFrontend(result);
    case 'event':
      return mapEventApiResultToFrontend(result);
  }
}

function mapPostApiResultToFrontend(result: ApiExhibitorNewsfeedResult): PostSearchResult {
  return {
    type: 'POST',
    id: result.id,
    name: result.name,
    fair_id: result.fair_id,
    image: {
      ...(result.media && { resource: result.media.resource, provider: result.media.provider }),
      ...(result.media === undefined && { resource: '', provider: 'RAW' }),
    },
    top_of_the_list: false,
    highlight: false,
    published_at: new Date(result.visible_from),
    short_description: result.teaser,
    exhibitor_id: result.channel_id,
    exhibitor_name: result.name,
  };
}

function mapProductApiResultToFrontend(result: ApiExhibitorNewsfeedResult): ProductSearchResult {
  return {
    type: 'PRODUCT',
    id: result.id,
    name: result.name,
    fair_id: result.fair_id,
    image: {
      ...(result.media && { resource: result.media.resource, provider: result.media.provider }),
      ...(result.media === undefined && { resource: '', provider: 'RAW' }),
    },
    top_of_the_list: false,
    highlight: false,
    published_at: new Date(result.visible_from),
    short_description: result.teaser,
    exhibitor_name: result.name,
    exhibitor_id: result.channel_id,
    exhibitor_address: {
      city: result.city,
      country: result.country,
    },
  };
}

function mapExhibitorApiResultToFrontend(result: ApiExhibitorNewsfeedResult): ExhibitorSearchResult {
  return {
    type: 'EXHIBITOR',
    id: result.id,
    name: result.name,
    fair_id: result.fair_id,
    image: {
      ...(result.media && { resource: result.media.resource, provider: result.media.provider }),
      ...(result.media === undefined && { resource: '', provider: 'RAW' }),
    },
    top_of_the_list: false,
    highlight: false,
    published_at: new Date(result.visible_from),
    short_description: result.teaser,
  };
}

function mapEventApiResultToFrontend(result: ApiExhibitorNewsfeedResult): EventSearchResult {
  return {
    type: 'EVENT',
    id: result.id,
    name: result.name,
    fair_id: result.fair_id,
    image: {
      ...(result.media && { resource: result.media.resource, provider: result.media.provider }),
      ...(result.media === undefined && { resource: '', provider: 'RAW' }),
    },
    top_of_the_list: false,
    highlight: false,
    published_at: new Date(result.visible_from),
    exhibitor_id: result.channel_id,
    exhibitor_name: result.name,
    starts_at: new Date(result.starts_at),
    ends_at: new Date(result.ends_at),
  };
}
